import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { InformationMenu } from '../InformationMenu';
import { GenerateSynthesisButton } from './GenerateSynthesisButton';
import { CancelSupervisionButton } from './CancelSupervisionButton';
import { DropdownMenuButton } from './DropdownMenuButton';
import { useSupervisionContext } from '../../../../contexts/SupervisionContext/SupervisionContext';

/**
 * Component for rendering buttons related to waiting bookings in supervisions.
 * @component
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.supervisionId - The ID of the supervision.
 * @param {Function} props.setCancelSupervisionModalVisible - Function to set the visibility of the cancel supervision modal.
 * @param {Function} props.setIsEmailModalOpen - Function to set the visibility of the email modal.
 * @returns {JSX.Element} The rendered component.
 */
export const WaitingBookingButtons = ({
  supervisionId,
  setCancelSupervisionModalVisible,
  setIsEmailModalOpen
}) => {
  const { t } = useTranslation();
  const {
    setRecipients,
    setTemplateType,
    setDocumentType,
    setFilterID,
    setRecordID,
    state: { supervision } = {}
  } = useSupervisionContext();

  return (
    <>
      <DropdownMenuButton
        overlay={
          <InformationMenu
            supervision={supervision}
            setRecipients={setRecipients}
            setIsEmailModalOpen={setIsEmailModalOpen}
            setTemplateType={setTemplateType}
            setDocumentType={setDocumentType}
            setFilterID={setFilterID}
            setRecordID={setRecordID}
          />
        }
        label={`${t('supervisions.show.buttons.send_informations')} `}
      />
      <GenerateSynthesisButton supervisionId={supervisionId} />
      <CancelSupervisionButton
        setCancelSupervisionModalVisible={setCancelSupervisionModalVisible}
      />
    </>
  );
};

WaitingBookingButtons.propTypes = {
  setCancelSupervisionModalVisible: PropTypes.func.isRequired,
  supervisionId: PropTypes.string.isRequired,
  supervision: PropTypes.shape({}).isRequired,
  setIsEmailModalOpen: PropTypes.func.isRequired
};
